module.exports = __webpack_public_path__ + "img/3.da56c554.png";